<template lang="pug">
#member-activity-overview
  WtTitle(card-title) Activity Overview
  .subheading.has-text-grey Totals
  WtStatRow(icon="blue-shoe" name="Steps" :value="_.get(data, 'stepTotal', '- -')")
  //- [auth.user optimism]
  WtStatRow(v-if="_.get($auth.user(), 'program.converter', false) || coreProgramMeta.converter" icon="blue-walk-man-icon" name="Activities" :value="_.get(data, 'activityTotal', '- -')")
  WtStatRow(icon="purple-mile-marker" :name="memberDistanceUnitText" :value="_.get(data, 'stepsDistance', '- -')")
  WtStatRow(icon="red-line-graph" name="Daily Avg. Steps" :value="_.get(data, 'stepAverage', '- -')")
  WtStatRow(icon="green-entries-icon" name="Entries" :value="_.get(data, 'numberOfEntries', '- -')")
</template>

<script>
import { mapGetters } from "vuex";
import WtStatRow from "@@/WtStatRow/WtStatRow";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "MemberActivityOverview",

  components: {
    WtStatRow,
    WtTitle
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("members", ["member", "memberLoaded"]),

    memberDistanceUnit() {
      return this.memberLoaded
        ? this._.get(this.member, "memberData.units", "")
        : this._.get(this.$auth.user(), "memberData.units", "");
    },

    memberDistanceUnitText() {
      return this.memberDistanceUnit === "Kilometers" ? "Kilometers" : "Miles";
    }
  }
};
</script>

<style lang="sass" scoped>
#member-activity-overview
  .subheading
    margin-top: -.5rem
    margin-bottom: .5rem
  .is-gray
    color: $grey
    font-size: 1rem
    font-family: $family-sans-serif
</style>
